import { Route, Routes as DomRoutes } from "react-router-dom"
import LoginPage from "./containers/LoginPage"
import AuthenticationPage from "./containers/AuthenticationPage"
import ResetPassword from "./containers/ResetPassword"
import NewPassword from "./containers/NewPassword"
import AuthenticatedRoute from "./AuthenticatedRoute"
import RouteGuard from "./RouteGuard"
import ClientList from "./containers/client/List"
import SubAdminList from "./containers/subadmin/List"
import React from "react"
import AuthenticationSetup from "./containers/AuthenticationSetup"
import AddAdmin from "./containers/admin/AddAdmin"
import AddSubAdmin from "./containers/subadmin/add"
import Dashboard from "./containers/overview/Dashboard"
import OverviewList from "./containers/request/List"
import AdminList from "./containers/admin/List"
import AddClient from "./containers/client/add"
import ClientDetail from "./containers/client/Detail"
import SelectedAdmin from "./containers/admin/SelectedAdmin"
import Setting from "./containers/setting"
import Logout from "./containers/Logout"
import AddRequest from "./containers/request/AddRequest"
import FeedbackList from "./containers/feedback/List"
import RequestDetails from "./containers/request/RequestDetails"
import PrivacyPolicy from "./containers/meta/PrivacyPolicy"
import TermsandConditions from "./containers/meta/TermsandConditions"
import TripTracking from "./containers/tracking/TripTracking"
import SchoolTracking from "./containers/tracking/SchoolTracking"
import DispatcherList from "./containers/dispatcher/list"
import AddDispatcher from "./containers/dispatcher/add"
import AddAidMonitor from "./containers/aidMonitor/add"
import DriverList from "./containers/driver/list"
import AddDriver from "./containers/driver/add"
import SubAdminDetail from "./containers/subadmin/Detail"
import VehicleList from "./containers/vehicle/List"
import VehicleDetail from "./containers/vehicle/details"
import AidMonitorList from "./containers/aidMonitor/list"
import GuardianList from "./containers/guardian/list"
import AddGuardian from "./containers/guardian/add"
import GuardianDetail from "./containers/guardian/Detail"
import DriverDetail from "./containers/driver/details"
import Appointments from "./components/appointments/Appointments"
import CancelledRides from "./containers/cancelled-rides/List"
import CancelledRidesDetail from "./containers/cancelled-rides/Detail"
import LandingPage from "./containers/landing/LandingPage"
import DirectMessage from "./containers/direct-message/user-channel-list"
import Chat from "./containers/direct-message/user-messaging"
import UserAccessManagementList from "./components/users/UserAccessManagementList"
import UserAccessManagementUpdateRole from "./components/users/UserAccessManagementUpdateRole"
import UserAccessManagementAddRole from "./components/users/UserAccessManagementAddRole"
import Incidents from "./containers/incidents/incidents"
import IncidentsDetail from "./containers/incidents/details"
import BasicDetails from "./containers/driver/basicDetails"
import MapViewListing from "./containers/map-view-listing/map-view-listing"
import MapViewListingDetails from "./containers/map-view-listing/map-view-listing-details"
import TrainingList from "./containers/training/list"
import CreateTraining from "./containers/training/add"
import TrainingDetails from "./containers/training/details"
import ManageReports from "./containers/reports/ManageReports"
import ReportDetails from "./containers/reports/ReportDetails"
import MyReports from "./containers/reports/MyReports"
import InspectionList from "./containers/inspection/list"
import Introduction from "./containers/introduction"
import TripLog from "./containers/trip-log/trip-log"
import LiveLocation from "./containers/live-location/live-location"
import BankAccountList from "./containers/bank-account/list"
import CallUser from "./containers/direct-message/call"
//import PhoneCalls from "./containers/phone-calls/phone-calls"
import TransactionList from "./containers/transactions/list"
import TransactionDetails from "./containers/transactions/transactionDetails"
import DriverInspectionDetails from "./components/driver/DriverInspectionDetails"

const Routes = () => {
  return (
    <DomRoutes>
      <Route path="/" element={<AuthenticatedRoute />}>
        {/* Routes available to any authenticated user (RouteGuard fallback targets) */}
        <Route path="/overview" element={<Dashboard />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/setting" element={<Setting />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/intro/" element={<Introduction />} />

        <Route
          path="/requests"
          element={
            <RouteGuard feature="REQUESTS">
              <OverviewList />
            </RouteGuard>
          }
        />
        <Route
          path="/requests/add-request"
          element={
            <RouteGuard feature="REQUESTS" userTypes={[1]}>
              <AddRequest />
            </RouteGuard>
          }
        />
        <Route
          path="/requests/:id"
          element={
            <RouteGuard feature="REQUESTS">
              <RequestDetails />
            </RouteGuard>
          }
        />
        <Route
          path="/admins"
          element={
            <RouteGuard feature="ADMINS">
              <AdminList />
            </RouteGuard>
          }
        />
        <Route
          path="/admins/add-admin"
          element={
            <RouteGuard feature="ADMINS">
              <AddAdmin />
            </RouteGuard>
          }
        />
        <Route
          path="/admins/:adminId"
          element={
            <RouteGuard feature="ADMINS">
              <SelectedAdmin />
            </RouteGuard>
          }
        />
        <Route
          path="/clients"
          element={
            <RouteGuard feature="CLIENTS">
              <ClientList />
            </RouteGuard>
          }
        />
        <Route
          path="/clients/add-client"
          element={
            <RouteGuard feature="CLIENTS">
              <AddClient />
            </RouteGuard>
          }
        />
        <Route
          path="/clients/:clientId"
          element={
            <RouteGuard feature="CLIENTS">
              <ClientDetail />
            </RouteGuard>
          }
        />
        <Route
          path="/direct-message"
          element={
            <RouteGuard feature="CHAT">
              <DirectMessage />
            </RouteGuard>
          }
        >
          <Route
            path="/direct-message/chat"
            element={
              <RouteGuard feature="CHAT">
                <Chat />
              </RouteGuard>
            }
          />
          <Route
            path="/direct-message/call/:pubnubId"
            element={
              <RouteGuard feature="CHAT">
                <CallUser />
              </RouteGuard>
            }
          />
        </Route>
        <Route
          path="/incidents"
          element={
            <RouteGuard feature="INCIDENT_REPORT">
              <Incidents />
            </RouteGuard>
          }
        >
          <Route
            path="/incidents/:id"
            element={
              <RouteGuard feature="INCIDENT_REPORT">
                <IncidentsDetail />
              </RouteGuard>
            }
          />
        </Route>
        <Route
          path="/vehicles"
          element={
            <RouteGuard feature="VEHICLES">
              <VehicleList />
            </RouteGuard>
          }
        />
        <Route
          path="/vehicles/:vehicleId"
          element={
            <RouteGuard feature="VEHICLES">
              <VehicleDetail />
            </RouteGuard>
          }
        />
        <Route
          path="/feedback"
          element={
            <RouteGuard feature="FEEDBACK">
              <FeedbackList />
            </RouteGuard>
          }
        />
        <Route
          path="/subadmins"
          element={
            <RouteGuard feature="SUBADMINS">
              <SubAdminList />
            </RouteGuard>
          }
        />
        <Route
          path="/subadmins/add"
          element={
            <RouteGuard feature="SUBADMINS">
              <AddSubAdmin />
            </RouteGuard>
          }
        />
        <Route
          path="/subadmins/:subAdminId"
          element={
            <RouteGuard feature="SUBADMINS">
              <SubAdminDetail />
            </RouteGuard>
          }
        />
        <Route
          path="/appointments"
          element={
            <RouteGuard feature="APPOINTMENTS">
              <Appointments />
            </RouteGuard>
          }
        />
        <Route
          path="/dispatchers"
          element={
            <RouteGuard feature="DISPATCHERS">
              <DispatcherList />
            </RouteGuard>
          }
        />
        <Route
          path="/dispatchers/add-dispatcher"
          element={
            <RouteGuard feature="DISPATCHERS">
              <AddDispatcher />
            </RouteGuard>
          }
        />
        <Route
          path="/dispatchers/:dispatcherId"
          element={
            <RouteGuard feature="DISPATCHERS">
              <AddDispatcher />
            </RouteGuard>
          }
        />
        <Route
          path="/aidmonitor"
          element={
            <RouteGuard feature="AID_MONITORS">
              <AidMonitorList />
            </RouteGuard>
          }
        />
        <Route
          path="/aidmonitor/add-aidmonitor"
          element={
            <RouteGuard feature="AID_MONITORS">
              <AddAidMonitor />
            </RouteGuard>
          }
        />
        <Route
          path="/aidmonitor/:id"
          element={
            <RouteGuard feature="AID_MONITORS">
              <AddAidMonitor />
            </RouteGuard>
          }
        />
        <Route
          path="/guardians"
          element={
            <RouteGuard feature="GUARDIAN">
              <GuardianList />
            </RouteGuard>
          }
        />
        <Route
          path="/guardians/add-guardian"
          element={
            <RouteGuard feature="GUARDIAN">
              <AddGuardian />
            </RouteGuard>
          }
        />
        <Route
          path="/guardians/edit/:guardianId"
          element={
            <RouteGuard feature="GUARDIAN">
              <AddGuardian />
            </RouteGuard>
          }
        />
        <Route
          path="/guardians/:guardianId"
          element={
            <RouteGuard feature="GUARDIAN">
              <GuardianDetail />
            </RouteGuard>
          }
        />
        <Route
          path="/drivers"
          element={
            <RouteGuard feature="DRIVERS">
              <DriverList />
            </RouteGuard>
          }
        />
        <Route
          path="/drivers/add-driver"
          element={
            <RouteGuard feature="DRIVERS">
              <AddDriver />
            </RouteGuard>
          }
        />
        <Route
          path="/drivers/:driverId"
          element={
            <RouteGuard feature="DRIVERS">
              <DriverDetail />
            </RouteGuard>
          }
        />
        <Route
          path="/drivers/:id/edit"
          element={
            <RouteGuard feature="DRIVERS">
              <AddDriver />
            </RouteGuard>
          }
        />
        <Route
          path="/drivers/:driverId/:inspectionId"
          element={
            <RouteGuard feature="DRIVERS">
              <DriverInspectionDetails />
            </RouteGuard>
          }
        />
        <Route
          path="/map-view-listing"
          element={
            <RouteGuard feature="MAP">
              <MapViewListing />
            </RouteGuard>
          }
        />
        <Route
          path="/map-view-listing/:id"
          element={
            <RouteGuard feature="MAP">
              <MapViewListingDetails />
            </RouteGuard>
          }
        />
        <Route
          path="/inspection"
          element={
            <RouteGuard feature="INSPECTION">
              <InspectionList />
            </RouteGuard>
          }
        />
        <Route
          path="/live-location"
          element={
            <RouteGuard feature="LIVE_LOCATION">
              <LiveLocation />
            </RouteGuard>
          }
        />
        <Route
          path="/bank-account"
          element={
            <RouteGuard feature="BANK_DETAILS">
              <BankAccountList />
            </RouteGuard>
          }
        />
        <Route
          path="/training"
          element={
            <RouteGuard feature="TRAINING">
              <TrainingList />
            </RouteGuard>
          }
        />
        <Route
          path="/training/add-training"
          element={
            <RouteGuard feature="TRAINING">
              <CreateTraining />
            </RouteGuard>
          }
        />
        <Route
          path="/training/:id/edit"
          element={
            <RouteGuard feature="TRAINING">
              <CreateTraining />
            </RouteGuard>
          }
        />
        <Route
          path="/training/:id"
          element={
            <RouteGuard feature="TRAINING">
              <TrainingDetails />
            </RouteGuard>
          }
        />
        {/* <Route path="/phonecalls" element={<PhoneCalls />} /> */}
        <Route
          path="/trip-log"
          element={
            <RouteGuard feature="TRIP_LOG">
              <TripLog />
            </RouteGuard>
          }
        />
        <Route
          path="/user-access-management"
          element={
            <RouteGuard feature="USER_ROLE">
              <UserAccessManagementList />
            </RouteGuard>
          }
        />
        <Route
          path="/user-access-management/add-user-role"
          element={
            <RouteGuard feature="USER_ROLE">
              <UserAccessManagementAddRole />
            </RouteGuard>
          }
        />
        <Route
          path="/user-access-management/:roleId"
          element={
            <RouteGuard feature="USER_ROLE">
              <UserAccessManagementUpdateRole />
            </RouteGuard>
          }
        />
        <Route
          path="/manage-reports"
          element={
            <RouteGuard feature="REPORTS">
              <ManageReports />
            </RouteGuard>
          }
        />
        <Route
          path="/manage-reports/:id"
          element={
            <RouteGuard feature="REPORTS">
              <ReportDetails />
            </RouteGuard>
          }
        />
        <Route
          path="/my-reports"
          element={
            <RouteGuard feature="MY_REPORTS">
              <MyReports />
            </RouteGuard>
          }
        />
        <Route
          path="/my-reports/:id"
          element={
            <RouteGuard feature="MY_REPORTS">
              <ReportDetails />
            </RouteGuard>
          }
        />
        <Route
          path="/cancelled-rides"
          element={
            <RouteGuard feature="CANCELLED_RIDES">
              <CancelledRides />
            </RouteGuard>
          }
        />
        <Route
          path="/cancelled-rides/:id"
          element={
            <RouteGuard feature="CANCELLED_RIDES">
              <CancelledRidesDetail />
            </RouteGuard>
          }
        />
        <Route
          path="/transactions"
          element={
            <RouteGuard feature="TRANSACTIONS">
              <TransactionList />
            </RouteGuard>
          }
        />
        <Route
          path="/transactions/:id"
          element={
            <RouteGuard feature="TRANSACTIONS">
              <TransactionDetails />
            </RouteGuard>
          }
        />
        <Route
          path="/transactions/:id/:id"
          element={
            <RouteGuard feature="TRANSACTIONS">
              <ReportDetails />
            </RouteGuard>
          }
        />

        <Route path="*" element={<div>Development is under progress</div>} />
      </Route>
      <Route exact path="/authsetup" element={<AuthenticationSetup />} />
      <Route exact path="/authenticate" element={<AuthenticationPage />} />
      <Route exact path="/resetpassword" element={<ResetPassword />} />
      <Route exact path="/reset-password-confirm" element={<NewPassword />} />
      <Route exact path="/login" element={<LoginPage />} />
      <Route path="/verify-driver" element={<BasicDetails />} />
      <Route exact path="/landing-page" element={<LandingPage />} />
      <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route exact path="/terms-conditions" element={<TermsandConditions />} />
      <Route path="/track/:trackingUuid" element={<TripTracking />} />
      <Route path="/school/:schoolUuid" element={<SchoolTracking />} />
      <Route path="/reports" element={<AdminList />} />
    </DomRoutes>
  )
}

export default Routes
